import { useQuery } from '@apollo/client';
import { buttonV2Class } from '@synoptic/ui-kit/button-v2/button-v2.css.js';
import { ArrowRightIcon } from '@synoptic/ui-kit/icons/react/arrow-right.js';
import { SkeletonV2 } from '@synoptic/ui-kit/skeleton-v2/skeleton-v2.js';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { useId } from 'react';
import { gql } from '@/__generated__/index.ts';
import { StreamCardLinkV2 } from '@/components/stream-card-v2/stream-card-link-v2.tsx';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import {
  exploreCardGridV2,
  exploreCardSkeletonV2,
  exploreSectionHeaderV2,
  exploreSectionHeadingV2,
  exploreSectionTitleV2,
  exploreSectionV2,
} from './explore-page-v2.css.ts';

const ExploreNewStreamsQuery = gql(`
  query ExploreNewStreamsQuery {
    streamsAll(
      limit: 4
      sortBy: CREATED_AT
      custom: false
      minFollowers: 3
      nextToken: null
    ) {
      items {
        ...StreamCardFragment
      }
      nextToken
    }
  }
`);

const SKELETON_COUNT = 4;

const renderSkeletons = () =>
  Array.from({ length: SKELETON_COUNT }, (_, index) => (
    <SkeletonV2
      key={index}
      className={exploreCardSkeletonV2}
      height={177}
      width="100%"
    />
  ));

export const ExploreNewStreamsSectionV2 = () => {
  const titleId = useId();
  const toast = useToast();
  const { data, loading } = useQuery(ExploreNewStreamsQuery, {
    fetchPolicy: 'cache-and-network',
    onError: () => {
      toast.error({
        title: 'Failed to fetch streams',
      });
    },
  });

  const streams = data?.streamsAll?.items;
  const showSkeletons = loading && !streams?.length;

  return (
    <section className={exploreSectionV2} aria-labelledby={titleId}>
      <header className={exploreSectionHeaderV2}>
        <div className={exploreSectionHeadingV2}>
          <h2 id={titleId} className={exploreSectionTitleV2}>
            New Streams on Synoptic
          </h2>
        </div>
        <Link className={buttonV2Class.secondary} to={paths.streams}>
          See all
          <ArrowRightIcon />
        </Link>
      </header>
      <div className={exploreCardGridV2}>
        {showSkeletons
          ? renderSkeletons()
          : streams?.map((stream) => (
              <StreamCardLinkV2 key={stream.id} stream={stream} />
            ))}
      </div>
    </section>
  );
};
